import client from './RestClient';
import _ from 'lodash';
import { AxiosInstance } from 'axios';

export interface TreeNode {
  id: string;
  label: string;
  children?: TreeNode[];
  value?: string;
}
export interface OutboundMetaWebService {
  getProductCategories(parentId?: string): Promise<TreeNode[]>;
}

function wrapTreeNode(json: any): TreeNode {
  return {
    id: _.get(json, 'id', ''),
    label: _.get(json, 'label', ''),
    value: _.get(json, 'value', _.get(json, 'id', '')),
    children: Array.isArray(json.children)
      ? json.children.map(wrapTreeNode)
      : undefined,
  };
}
export class RestfulCampaignWebService implements OutboundMetaWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getProductCategories(): Promise<TreeNode[]> {
    const response = await this.restClient.get('/outbound/meta-segment-list');
    return response.data.records.map(wrapTreeNode);
  }
}
